const MARITAL_STATUS_TYPE = {
  SINGLE: 'single',
  MARRIED: 'married',
  DIVORCED: 'divorced',
  WIDOWED: 'widowed',
};

export default MARITAL_STATUS_TYPE;
